import { Monitor, Moon, Sun } from "lucide-react";
import { useThemeStore } from "@/stores/theme-store";

const options = [
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
  { value: "system", label: "System", icon: Monitor },
] as const;

export function ThemeSelector() {
  const preference = useThemeStore((s) => s.preference);
  const setPreference = useThemeStore((s) => s.setPreference);
  return (
    <div role="group" aria-label="Appearance" className="seg w-full">
      {options.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          className="flex-1 justify-center px-1.5!"
          aria-label={`${label} theme`}
          aria-pressed={preference === value}
          onClick={() => setPreference(value)}
        >
          <Icon size={13} aria-hidden />
          {label}
        </button>
      ))}
    </div>
  );
}
